import React, { useState, useCallback } from "react";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";

export const PhotoGallery = ({ photos, columns }) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  return (
    <div>
      <Gallery photos={photos} onClick={openLightbox} columns={columns} />
      <ModalGateway>
        {viewerIsOpen ? (
          <Modal
            allowFullscreen={true}
            isFullScreen={true}
            onClose={closeLightbox}
          >
            <Carousel
              frameProps={{ autoSize: false }}
              allowFullscreen={true}
              isFullScreen={true}
              currentIndex={currentImage}
              views={photos.map((x) => ({
                ...x,
                autoSize: true,
                srcset: x.srcSet,
                caption: x.title,
              }))}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    </div>
  );
};
